import { ProjectData } from "types";
import { Transforms, Element, Range } from "slate";

import {
  CustomEditor,
  ProjectDataElement,
} from "components/ManualBuilder/types";

export interface ProjectDataPlaceholder {
  key: string;
}

export interface PlaceholderGroup {
  label: string;
  options: ProjectDataPlaceholder[];
}

export const PROJECT_DATA_PLACEHOLDERS: PlaceholderGroup[] = [
  {
    label: "projectdata.label",
    options: [
      "projectdata.description",
      "projectdata.product_name",
      "projectdata.type",
      "projectdata.serial_number",
      "projectdata.category",
      "projectdata.launch_date",
    ].map((key) => ({ key })),
  },
  {
    label: "manufacturer.label",
    options: [
      "manufacturer.company",
      "manufacturer.street_address",
      "manufacturer.post_code",
      "manufacturer.city",
      "manufacturer.country",
      "manufacturer.phone",
      "manufacturer.email_adress",
      "manufacturer.website",
    ].map((key) => ({ key })),
  },
  {
    label: "boundary.label",
    options: [
      "boundary.expected_misuse",
      "boundary.expected_usage",
      "boundary.location",
      "boundary.spatial_boundary",
      "boundary.electrical_voltage",
      "boundary.power_consumption",
      "boundary.grid_protection",
      "boundary.temperature",
      "boundary.humidity",
      "boundary.usage_environment",
      "boundary.load_limit",
      "boundary.dimensions",
      "boundary.noise_emission",
      "boundary.weight",
      "boundary.hydraulic_max",
      "boundary.pneumatic_max",
    ].map((key) => ({ key })),
  },
];

export const insertProjectDataPlaceholder = (
  editor: CustomEditor,
  key: string
): void => {
  if (!editor.selection) return;

  const projectData: ProjectDataElement = {
    type: "project-data",
    key,
    children: [{ text: "" }],
  };

  // If there's a selection range, delete it first
  if (!Range.isCollapsed(editor.selection)) {
    Transforms.delete(editor);
  }

  // Insert at the current selection point
  Transforms.insertNodes(editor, projectData, {
    at: editor.selection,
    select: true,
  });

  // Move cursor after the placeholder
  Transforms.move(editor);
};

export const isProjectDataElement = (
  element: Element
): element is ProjectDataElement => {
  return element.type === "project-data";
};
